import Box from '@mui/material/Box';
import type { Person } from '@tyro/api';
import {
  type AvatarProps as CoreAvatarProps,
  RouterLink,
  type RouterLinkProps,
  usePreferredNameLayout,
} from '@tyro/core';
import { StudentAvatar } from '../students/student-avatar';

type TableAvatarProps = {
  to?: string | null;
  person:
    | Pick<Person, 'avatarUrl' | 'firstName' | 'lastName' | 'partyId'>
    | undefined;
  isPriorityStudent?: boolean;
  hasSupportPlan?: boolean;
  hasMedical?: boolean;
  currentGroup?: {
    partyId: number;
    name: string;
  };
  AvatarProps?: CoreAvatarProps;
  avatarBackgroundColor?: string;
  size?: number;
  onBeforeNavigate?: () => void;
  hideAvatar?: boolean;
  target?: RouterLinkProps['target'];
};

export function StudentTableAvatar({
  to,
  person,
  isPriorityStudent = false,
  hasSupportPlan = false,
  hasMedical = false,
  currentGroup,
  AvatarProps,
  avatarBackgroundColor,
  size,
  onBeforeNavigate,
  hideAvatar,
  target,
}: TableAvatarProps) {
  const { displayName } = usePreferredNameLayout();
  const name = displayName(person);

  return (
    <Box display="flex" alignItems="center" width="100%">
      {hideAvatar ? null : (
        <StudentAvatar
          src={person?.avatarUrl}
          partyId={person?.partyId ?? 0}
          name={name}
          isPriorityStudent={isPriorityStudent}
          hasSupportPlan={hasSupportPlan}
          hasMedical={hasMedical}
          currentGroup={currentGroup}
          avatarBackgroundColor={avatarBackgroundColor}
          size={size}
          person={person}
          ContainingButtonProps={{
            sx: {
              my: 1,
              mr: 1.5,
            },
          }}
          AvatarProps={{ ...AvatarProps, person }}
        />
      )}
      {to ? (
        <RouterLink
          sx={{ fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis' }}
          to={to}
          target={target}
          onClick={onBeforeNavigate}
        >
          {name}
        </RouterLink>
      ) : (
        <Box component="span">{name}</Box>
      )}
    </Box>
  );
}
